document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.content_switcher-layout").forEach((layout) => {
        const items = [...layout.querySelectorAll(".switch-item")];
        const toggles = items.map((item) => item.querySelector(".switch-item-toggle"));
        const stacked = window.matchMedia("(max-width: 992px)");
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
        if (!toggles.length) return;

        const open = (index, { focus = false, reveal = false } = {}) => {
            items.forEach((item, i) => {
                const isOpen = i === index;
                const toggle = toggles[i];
                const [summaryId, panelId] = toggle.getAttribute("aria-controls").split(" ");
                const summary = layout.querySelector(`#${summaryId}`);
                const panel = layout.querySelector(`#${panelId}`);

                item.classList.toggle("is-open", isOpen);
                toggle.setAttribute("aria-expanded", String(isOpen));
                if (summary) summary.inert = !isOpen;
                if (panel) panel.hidden = !isOpen;

                if (isOpen && focus) toggle.focus();
                if (isOpen && reveal && panel && stacked.matches) {
                    panel.scrollIntoView({ behavior: reduceMotion.matches ? "auto" : "smooth", block: "nearest" });
                }
            });
        };

        const autoplay = layout.hasAttribute("data-autoplay") && !reduceMotion.matches && toggles.length > 1;
        const hold = new Set();
        let current = 0;

        const stop = () => {
            layout.classList.remove("is-autoplay", "is-paused");
        };

        const pause = (reason, paused) => {
            paused ? hold.add(reason) : hold.delete(reason);
            layout.classList.toggle("is-paused", hold.size > 0);
        };

        if (autoplay) {
            layout.classList.add("is-autoplay");

            layout.addEventListener("animationend", (event) => {
                if (event.animationName !== "content-switch-progress" || !layout.classList.contains("is-autoplay")) return;
                current = (current + 1) % toggles.length;
                open(current);
            });

            layout.addEventListener("mouseenter", () => pause("hover", true));
            layout.addEventListener("mouseleave", () => pause("hover", false));
            layout.addEventListener("focusin", () => pause("focus", true));
            layout.addEventListener("focusout", (event) => {
                if (!layout.contains(event.relatedTarget)) pause("focus", false);
            });

            new IntersectionObserver(([entry]) => pause("offscreen", !entry.isIntersecting), { threshold: 0.25 }).observe(layout);
            reduceMotion.addEventListener("change", (event) => event.matches && stop());
        }

        toggles.forEach((toggle, index) => {
            toggle.addEventListener("click", () => {
                stop();
                if (toggle.getAttribute("aria-expanded") === "true") return;
                current = index;
                open(index, { reveal: true });
            });

            toggle.addEventListener("keydown", (event) => {
                const keys = {
                    ArrowDown: (index + 1) % toggles.length,
                    ArrowUp: (index - 1 + toggles.length) % toggles.length,
                    Home: 0,
                    End: toggles.length - 1,
                };
                if (!(event.key in keys)) return;

                event.preventDefault();
                toggles[keys[event.key]].focus();
            });
        });
    });
});
